import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import { INITIAL_USE_INTERNAL_TUNNEL_BOOKING_FILTERS } from './internalHooks/useInternalTunnelBookingFilters/const';
export const INITIAL_TUNNEL_CONTEXT = {
    tunnelStep: null,
    experienceId: null,
    experience: null,
    isBookingStep: false,
    isValidationStep: false,
    bookingType: FTunnelPageBookingTypeEnum.standard,
    tunnelBookingFilters: INITIAL_USE_INTERNAL_TUNNEL_BOOKING_FILTERS
};
